import { TFunction } from 'i18next';

export const VEHICLE_TYPE = (t: TFunction) => {
  return [
    { label: t('leadGenConst.Truck'), value: 'Truck', icon: 'src/assets/images/lead-gen/truck.svg' },
    { label: t('leadGenConst.Car'), value: 'Car', icon: 'src/assets/images/lead-gen/car.svg' },
    { label: t('leadGenConst.Minivan'), value: 'Minivan', icon: 'src/assets/images/lead-gen/minivan.svg' },
    { label: t('leadGenConst.SUV'), value: 'SUV', icon: 'src/assets/images/lead-gen/suv.svg' },
  ];
};

export const BUDGET_OPTION = (t: TFunction) => {
  return [
    { label: t('leadGenConst.budgetOpt1'), value: 'UNDER $250 /MONTH' },
    { label: t('leadGenConst.budgetOpt2'), value: '$250 - $375 /MONTH' },
    { label: t('leadGenConst.budgetOpt3'), value: '$376 - $500 /MONTH' },
    { label: t('leadGenConst.budgetOpt4'), value: '$501 + /MONTH' },
  ];
};

export const CREDIT_SCORE_OPTION = (t: TFunction) => {
  return [
    { label: t('leadGenConst.creditScoreOpt1'), value: 'Good (650+)' },
    { label: t('leadGenConst.creditScoreOpt2'), value: 'Fair (550 - 649)' },
    { label: t('leadGenConst.creditScoreOpt3'), value: 'Poor (400 - 549)' },
    { label: t('leadGenConst.creditScoreOpt4'), value: 'Very Poor (399 or Less)' },
    { label: t('leadGenConst.creditScoreOpt5'), value: 'Current Bankruptcy' },
    { label: t('leadGenConst.creditScoreOpt6'), value: 'No Credit' },
  ];
};

export const EMPLOYMENT_STATUS_OPTION = (t: TFunction) => {
  return [
    { label: t('leadGenConst.employmentOpt1'), value: 'Employed' },
    { label: t('leadGenConst.employmentOpt2'), value: 'Student' },
    { label: t('leadGenConst.employmentOpt3'), value: 'Homemaker' },
    { label: t('leadGenConst.employmentOpt4'), value: 'Self-Employed' },
    { label: t('leadGenConst.employmentOpt5'), value: 'Retired' },
    { label: t('leadGenConst.employmentOpt6'), value: 'Other' },
  ];
};

export const SCHOOL_OPTION = (t: TFunction) => {
  return [
    { label: t('leadGenConst.yes'), value: 'yes' },
    { label: t('leadGenConst.no'), value: 'no' },
  ];
};

export const RENT_OR_OWN = (t: TFunction) => {
  return [
    { label: t('leadGenConst.rent'), value: 'rent' },
    { label: t('leadGenConst.own'), value: 'own' },
  ];
};

export const SECOND_SOURCE_INCOME = (t: TFunction) => {
  return [
    { label: t('leadGenConst.yes'), value: 'yes' },
    { label: t('leadGenConst.no'), value: 'no' },
  ];
};

export const ADDRESS_OPTION = (t: TFunction) => {
  return [
    { label: t('leadGenConst.addressLookup'), value: 'lookup' },
    { label: t('leadGenConst.addAddressManually'), value: 'manual' },
  ];
};

// export const checkStepExist = (stepsArray: StepConfigItem[], targetStepNumber: number) => {
//   return stepsArray.some((stepObject) => {
//     const step = Object.values(stepObject)[0];
//     return step.step === targetStepNumber;
//   });
// };

// export const checkStepExist = (stepsArray: number[], targetStepNumber: number) => {
//   return stepsArray.includes(targetStepNumber);
// };

export const checkStepExist = (stepsArray: number[], targetStepNumber: number) => {
  const index = stepsArray.indexOf(targetStepNumber);
  return index !== -1 ? index : undefined;
};
export const MODULE_NAME = 'leadGen';
